interface DropdownItemOptions {
  onClick: (item: DropdownItem) => void;
}

export class DropdownItem {
  private SELECTED_CLASS = 'dropdown__item--selected';

  private readonly _element: Element;
  private readonly _options: DropdownItemOptions;
  private readonly _key: string;
  private readonly _value: string;

  constructor(itemElement: Element, options: DropdownItemOptions) {
    this._element = itemElement;
    this._options = options;

    this._key = itemElement.getAttribute('data-key') || '';
    this._value = itemElement.getAttribute('data-label') || '';

    this.setupEventHandlers();
  }

  public getKey() {
    return this._key;
  }

  public getValue() {
    return this._value;
  }

  public isSelected() {
    return this._element.classList.contains(this.SELECTED_CLASS);
  }

  public select() {
    this._element.classList.add(this.SELECTED_CLASS);
  }

  public deselect() {
    this._element.classList.remove(this.SELECTED_CLASS);
  }

  public destroy() {
    this._element.removeEventListener('click', this.handleClick);
  }

  private handleClick = () => {
    this._options.onClick(this);
  };

  private setupEventHandlers() {
    this._element.addEventListener('click', this.handleClick);
  }
}
